module.exports = __webpack_public_path__ + "img/碳排总览-版本2@1x.3cda1127.png";